// extracted by mini-css-extract-plugin
module.exports = {"result":"result--iuDF3"};